import { Button, Grid } from "@material-ui/core"
import React from "react"
import Typography from "@material-ui/core/Typography"

export const BannerDetail = ({
  classes,
  title,
  smallDesc,
  price,
  discountedPrice,
  preOrderText,
  buyLabel,
  onBuyCourseClick,
}) => (
  <Grid container spacing={4}>
    <Grid item xs={12} md={6}>
      <TitleSmallDesc title={title} smallDesc={smallDesc} classes={classes} />
    </Grid>
    <Grid item xs={12} md={6}>
      <PriceBuyNow
        buyLabel={buyLabel}
        price={price}
        discountedPrice={discountedPrice}
        preOrderText={preOrderText}
        classes={classes}
        onBuyCourseClick={onBuyCourseClick}
      />
    </Grid>
  </Grid>
)

const TitleSmallDesc = ({ title, smallDesc, classes }) => (
  <Grid container>
    <Grid item xs={12}>
      <Grid container justify={"center"}>
        <Grid item>
          <Typography variant={"h4"} align="center">
            {title}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12} className={classes.smallDesc}>
      <Grid container justify={"center"}>
        <Grid item>
          <Typography variant={"subtitle1"}>{smallDesc}</Typography>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
)

const PriceBuyNow = ({
  price,
  discountedPrice,
  preOrderText,
  buyLabel,
  classes,
  onBuyCourseClick,
}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container justify="center" spacing={2}>
          <Grid item>
            <Typography variant={"h5"} color={discountedPrice ? "textSecondary": "textPrimary"}>
              {discountedPrice && <s>{price}</s>}
              {!discountedPrice && <>{price}</>}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant={"h5"}>{discountedPrice}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} className={classes.buyNowButtonItem}>
        <Grid container justify={"center"}>
          <Grid item>
            <Button
              aria-label={buyLabel}
              variant={"contained"}
              size={"large"}
              color={"primary"}
              onClick={onBuyCourseClick}
            >
              {buyLabel}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {preOrderText && (
        <Grid item xs={12} className={classes.preOrderText}>
          <Grid container justify={"center"}>
            <Grid item xs={6} xl={12}>
              <Typography align={"center"} variant={"body2"}>
                {preOrderText}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
